import { memo, useCallback, useState } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';

import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface IErknmReasonsCancelledDocument {
  className?: string;
  disableToAdd: boolean;
  formRef: IKnmFormRef | undefined;
  isWatchOnly: boolean;
  name: string;
  title?: string;
}

export const ErknmReasonsCancelledDocument = memo(
  ({ className = '', disableToAdd, formRef, isWatchOnly, name, title = 'Файл' }: IErknmReasonsCancelledDocument) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={className}>
        <div className="shared-group-label">
          {title}
          <Button
            className="shared-btn-add"
            text="Добавить"
            variant="link"
            color="primary"
            type="button"
            id="fileAddButton"
            disabled={isWatchOnly || disableToAdd}
            onClick={openSignModal}
          />
        </div>
        <KnmAttachmentsSigning
          isWatchOnly={isWatchOnly}
          name={name}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
      </div>
    );
  },
);
